import type { Locale } from '@hlt/contracts';

/**
 * Launch locales for the public site. Kept free of runtime package imports so the tiny browser
 * script can use it without pulling the contracts bundle into public pages.
 */
export const publicLocales = ['en', 'de', 'es', 'fr', 'tr'] as const satisfies readonly Locale[];

export const publicLocaleNames: Record<Locale, string> = {
    en: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    tr: 'Türkçe',
};

export const isPublicLocale = (value: string): value is Locale => (publicLocales as readonly string[]).includes(value);

/**
 * Choose the landing locale for `/`: an explicit earlier choice wins, then the first supported
 * browser language, then English. Never based on IP or region.
 */
export function bestLocale(stored: string | null, preferred: readonly string[]): Locale {
    if (stored !== null && isPublicLocale(stored)) return stored;
    for (const tag of preferred) {
        const base = tag.toLowerCase().split('-')[0] ?? '';
        if (isPublicLocale(base)) return base;
    }
    return 'en';
}
